import { GradPlanningTransferMetricCtrl } from './grad-planning-metric-transfer.controller';

export const GradPlanningMetricTransfer = {
  controller: GradPlanningTransferMetricCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./grad-planning-metric-transfer.html'),
};
